import { h } from "@stencil/core";

/* eslint-disable max-len */
export const FilterOutline = () => (
    <svg viewBox='0 0 48 48' role='img' fill='currentColor'>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M39.9419 8L28.0002 24.319V33.4124L20.0002 41.4124V24.321L8.05859 8H39.9419ZM35.9992 9.999H11.9992L22.0002 23.6675V36.583L26.0002 32.583V23.6654L35.9992 9.999Z'
        />
    </svg>
);
